import { render } from "./CarePlan.vue?vue&type=template&id=2a275940"
import script from "./CarePlan.vue?vue&type=script&lang=js"
export * from "./CarePlan.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__